import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import CommonColorPickerQuestion from 'themes/common/components/questions/colorPicker/ColorPickerQuestion'

interface ColorPickerQuestionProps {
  question: DenormalizedCustomizableQuestion
  createColorAnswer: (questionId: string, color: string) => void
  updateColorAnswer: (questionId: string, answerId: string, color: string) => void
  selectAnswer: (answerId: string) => void
}

const ColorPickerQuestion = ({ selectAnswer, ...props }: ColorPickerQuestionProps) => {
  return <CommonColorPickerQuestion {...props} selectAnswer={(_questionId, answerId) => selectAnswer(answerId)} />
}

export default ColorPickerQuestion
